import React, { useEffect, useState } from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DATASOURCE_METRICS_BACKEND_CONSOLE } from '@intelligence/pages/TopCharts/PCGames/_config/constant';
import { MetricsTableComp } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/Page';
import { defaultMetrictableApiParams } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import { consleMetricTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { dbiTopChartsBtnLogMes } from '@/pages/intelligence/utils/topChartsBuriedPointCfg';
import { history } from 'umi';
import {
  getTopPCMetricTableCustomValidUrlParams,
  topchartConsoleMetrictableValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import {
  getOriginalShortLinkFilter,
  URL_FILTER_KEY,
  URL_CHART_METRIC,
  URL_CHART_TYPE,
  URL_TABLE_SCROLL_SEG,
} from '@intelligence/utils/urlPathCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

export default function ConsoleMetricsTable() {
  const entityType = 'console';
  const filterKeyList = [
    filterKeyMap.MY_FILTER,
    filterKeyMap.RANGE_TIME,
    filterKeyMap.REGION,
    filterKeyMap.GENRETOR,
    filterKeyMap.ALL_Games,
    filterKeyMap.PUBLISHER,
    filterKeyMap.ALL_COMPANYS,
    filterKeyMap.RELEASE_TIME,
  ];
  const companyFilterParams = {
    entity_type: entityType,
    source: 'mscience',
    data_sources: ['newzoo', 'mscience', 'npd'],
    metric: 'revenue',
    region_type: 'region',
    regions: ['global'],
    granularity: 'monthly',
    start_date: '',
    end_date: '',
    page_size: 500,
    search_name: '',
    page: 1,
    source_metric: {
      mscience: ['revenue'],
    },
  };

  const defaultParams = {
    ...defaultMetrictableApiParams,
    entity_type: entityType,
    order_metric: 'digitalRevenue',
    order_source: 'mscience',
    source_metrics: DATASOURCE_METRICS_BACKEND_CONSOLE,
    topchart_name: 'Metrics Table',
    region_type: 'market',
    regions: ['global'],
    date_type: 'monthly',
    gsd_types: ['NETWORK'],
  };

  const hasUrlShortLink = hasShortLinkRatio.topConsoleMetrictable;
  const [shortLinkLoading, setShortLinkLoading] = useState(hasUrlShortLink);
  const [urlCustomParams, setUrlCustomParams] = useState({});
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState({
    [URL_CHART_TYPE]: topchartConsoleMetrictableValidCfg?.[URL_CHART_TYPE]?.[0],
    [URL_CHART_METRIC]:
      topchartConsoleMetrictableValidCfg?.[URL_CHART_METRIC]?.[0],
    [URL_TABLE_SCROLL_SEG]:
      topchartConsoleMetrictableValidCfg?.[URL_TABLE_SCROLL_SEG]?.[0],
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const initPage = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    if (urlFilter) {
      // 有的筛选器的token时才用后面的参数，没有则不用
      const { params, validQuery } = getTopPCMetricTableCustomValidUrlParams(
        history,
        topchartConsoleMetrictableValidCfg,
        consleMetricTableCloums,
      );
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  useEffect(() => {
    // 进入页面时判断是否有tokenQuery等，有则进入
    initPage();
  }, []);

  return (
    <>
      <MarqueeBanner />
      <MetricsTableComp
        entityType={entityType}
      pageLogInfoMes={dbiPageLogMes.topChartsConsoleGamesMetricsTable}
      filterKeyList={filterKeyList}
      companyFilterParams={companyFilterParams}
      defaultParams={defaultParams}
      tableCloumsList={consleMetricTableCloums}
      downloadLogConfig={
        dbiTopChartsBtnLogMes?.[
          `${entityType}_${TopchartPageId?.MetricsTable}_TopChartsMetricsTableDownload`
        ]
      }
      downloadBtnLogConfig={
        dbiTopChartsBtnLogMes?.[
          `${entityType}_${TopchartPageId?.MetricsTable}_TopChartsMetricsTableDownloadBtn`
        ]
      }
      hasUrlShortLink={hasUrlShortLink}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
      shortLinkLoading={shortLinkLoading}
      hasScrollTableSegment={true}
    />
    </>
  );
}
